import React from "react";
import PropTypes from "prop-types";

const PourAndDispenseModalCloseIcon = ({ onClick }) => {
  return (
    <button
      type="button"
      aria-label="Close dialog"
      onClick={onClick}
      className="pour_and_dispense_close_icon_container"
    >
      <span className="fa fa-times" aria-hidden="true" />
    </button>
  );
};

PourAndDispenseModalCloseIcon.propTypes = {
  onClick: PropTypes.func
};

export default PourAndDispenseModalCloseIcon;
